// extracted by mini-css-extract-plugin
module.exports = {"main-component":"objectives_main-component__LX83-"};